import { useEffect, useState } from 'react';

// Most a vhostod alapján IP-n megy az API.
// Ha később proxyzol ("/api/"), elég ezt ''-re cserélni.
const API_BASE = 'http://193.225.239.5/backend2';

export default function ViewCounter() {
  const [count, setCount] = useState(null);
  const [src, setSrc] = useState('szerver');
  const [err, setErr] = useState(null);

  useEffect(() => {
    let aborted = false;

    async function load() {
      try {
        // növel + visszaad összesen
        const r = await fetch(`${API_BASE}/api/views`, { method: 'POST' });
        const j = await r.json();
        if (!aborted) {
          setCount(j?.data?.total ?? 0);
          setSrc(j?.source || 'szerver');
        }
      } catch {
        // fallback: csak lekérdezés
        try {
          const r2 = await fetch(`${API_BASE}/api/views`);
          const j2 = await r2.json();
          if (!aborted) {
            setCount(j2?.data?.total ?? 0);
            setSrc(j2?.source || 'szerver');
          }
        } catch {
          if (!aborted) setErr('—');
        }
      }
    }

    load();
    return () => { aborted = true; };
  }, []);

  return (
    <div style={{
      position: 'absolute', left: 120, bottom: 12, zIndex: 600,
      background: 'rgba(0,0,0,0.55)', color: '#fff',
      padding: '6px 8px', borderRadius: 6,
      fontSize: 12, lineHeight: 1.2
    }}>
      <div>👁 Total views: <strong>{count ?? err ?? '…'}</strong></div>
    </div>
  );
}
